<template>
    <div class="contacto">
      <div class="main col-lg-12" >
        <h5 class="col-lg-12">Panel de Categorías.</h5>
        
        <div class="container row" id="top">
          <div class="form-group text-left col-lg-4">
            <label for="categoria">Seleccionar una categoría para editar</label>
            <select v-model="categoriaSelected" class="form-control" id="slcCategoria">
              <option :value="null" >Seleccionar</option>
              <option v-for="cat in categorias" :value="cat" :key="cat.id">{{cat.nombre}}</option>
            </select>
          </div>
          <div class="form-group text-left col-lg-4">
            <label for="categoria">Categorías (visibles)</label>
            <select class="form-control" id="slcCategoria">
              <option :value="null" >Todas</option>
              <option v-for="cat in categoriasV" :value="cat.id" :key="cat.id">{{cat.nombre}}</option>
            </select>
          </div>
          <div class="form-group text-right col-lg-4">
            <b-button pill v-b-modal.category-modal class="btnAdd"><i class="fa fa-plus mr-3"></i> Crear Categoría</b-button>
          </div>
        </div>

        <b-modal ref="category-modal" id="category-modal" no-close-on-backdrop scrollable hide-header>
          <div class="d-block text-center">
            <div class="col-lg-12">
              <h2>{{modal_title}}</h2>
              <ValidationObserver ref="form" >
                <b-form id="categoria" class="form-container">
                  <div class="form-group">
                      <label for="nombre">Nombre</label>
                      <ValidationProvider rules="required|max:200"  v-slot="{ errors }">
                        <b-form-input v-model="categoria.nombre" name="nombre" type="text" placeholder="Nombre"/>
                        <span class="error">{{ errors[0] }}</span>
                      </ValidationProvider>
                  </div>
                  <div class="form-group">
                    <label for="message">Descripción</label>
                    <ValidationProvider rules="required|max:200"  v-slot="{ errors }">
                      <b-form-textarea v-model="categoria.descripcion" rows="3" name="descripcion"/>
                      <span class="error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group text-left">
                    <label>Visible</label>
                    <b-form-checkbox type="checkbox" v-model="categoria.activo"></b-form-checkbox>
                  </div>
                </b-form>
              </ValidationObserver>
            </div>
          </div>
          <template #modal-footer="{}">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button v-show="!loading && !editing" type="submit" pill class="btnSend " @click="onSubmit()">Guardar</b-button>
            <b-link v-show="!loading && !editing" class="btnCancel" @click="$refs['category-modal'].hide();"></b-link>
            <b-button v-show="!loading && editing" type="submit" pill class="btnSend " @click="onSubmit()">Guardar Cambios</b-button>
            <b-link v-show="!loading && editing" class="btnCancel" @click="reset();"></b-link>
            <b-button v-show="loading" class="btnSend" pill disabled="disabled"><b-spinner small class="mr-2"></b-spinner>ENVIANDO</b-button>
          </template>
        </b-modal><!--main-center"-->
      </div><!--main-->
    </div>
</template>

<script>

import categoriasApi from "../api/categorias"
import {ValidationProvider,ValidationObserver} from 'vee-validate';
import Notify from "@/plugins/notify";

export default {
  name: 'category-manager',
  components: {
      ValidationProvider,
      ValidationObserver
  },
  data() {
      return {
        modal_title : "Nueva Categoría",
        categorias  : [],
        categoriasV : [],
        categoria   : {
            id          : null,
            nombre      : '',
            descripcion : '',
            activo      : true
        },
        categoriaSelected : null,
        show        : true,
        loading     : false,
        editing     : false,
      }
    },
    watch: {
      categoriaSelected:{
        deep:true,
        handler(newVal){
          this.fillEditForm();
        }
      }
    },
    methods: {
    fillEditForm(){
      this.editing = true;
      this.categoria.id = this.categoriaSelected.id;
      this.modal_title = "Editar Post";
      this.categoria.nombre = this.categoriaSelected.nombre; 
      this.categoria.descripcion = this.categoriaSelected.descripcion; 
      this.categoria.activo = this.categoriaSelected.activo;
      this.$refs['category-modal'].show();
    },
    onSubmit(){
      if(this.editing){
        this.updateCategory();
      }else{
        this.postCategory();
      }
    },
    getCategorias(){
      let parametros = {paginate:false,items_to_show:10,order:"asc",order_by:"id"};
      categoriasApi
      .getCategorias(parametros)
      .then(response => {
        this.categorias = response.data.data;
        this.categoriasV = response.data.data.filter((item)=>item.activo == true);
      }).catch(err => {
        console.log("Ocurrio un error al cargar las categorías.");
      });
    },
    async postCategory(){
      var isValid = await this.$refs.form.validate();
      if (!isValid) {
        Notify.WarningToast("Verifique que los campos obligatorios estén completos.");
      }else{
        this.loading = true;
        
      await categoriasApi
        .createCategoria(this.categoria)
        .then(response => {
          Notify.Success("¡Excelente!", "El artículo: "+this.categoria.nombre+", se agrego con éxito.");
          this.reset();
          this.getCategorias();
          this.$refs['category-modal'].hide();
        }).catch(err => {
          if(err.response.data.error != undefined)
            Notify.Error("No pudimos guardar los cambios", "",err.response.data.error);
          else
            Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible actualizar el artículo, inténtalo nuevamente.");
        });
      }
      this.loading = false;
    },
    async updateCategory(){
     var isValid = await this.$refs.form.validate();
      if (!isValid) {
        Notify.WarningToast("Verifique que los campos obligatorios estén completos.");
      }else{
       this.loading = true;
        
       await categoriasApi
          .updateCategoria(this.categoria)
          .then(response => {
            Notify.Success("¡Excelente!", "El artículo: "+this.categoria.nombre+", se actualizó con éxito.");
            this.reset();
            this.getCategorias();
            this.$refs['category-modal'].hide();
          }).catch(err => {
            if(err.response.data.error != undefined)
              Notify.Error("No pudimos guardar los cambios", "",err.response.data.error);
            else
              Notify.Error("No eres tu, somos nostros.", "","Lo sentimos, en este momento no fue posible actualizar el artículo, inténtalo nuevamente.");
          });
      }
      this.loading = false;
    },
    reset() {
      this.categoria ={
            id:null,
            nombre:'',
            descripcion:'',
            activo:true,
        },
        
      this.$nextTick(() => {
          
          this.$refs.form.reset();
          this.modal_title = "Nuevo Post";
          this.editing = false;
          this.categoriaSelected = null;
          this.$refs['category-modal'].hide();
          window.location = "#top";
        });
      },
    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    },
    init(){
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera;
      this.getCategorias();
    }
  },
  created () {
    this.init();
  },
}
</script>

<style scoped>
h2{
  font-family: Muli;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 50px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2px;
  color: #1E2245;
}

.postImage img{
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ced3da;
}
.google-terms{
     margin:15px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 15px;
    color: #828282;
}
.error{
    font-family: Muli;
    font-style: normal;
    font-size: 12px;
    color:red;
}
    h5 {
        font-family: Muli;
        font-style: normal;
        font-size: 38px;
        line-height: 18px;

        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2144;

        margin: 100px 0px;
    }
    .btnAdd {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background:#1E2245;
    border-color:#1E2245!important;
    border-radius: 18px;
    color: #FFFFFF;
    margin-top: 30px;
    padding: 13px 27px;
  }
  .btnAdd > i{
    color:#2DB9D1;
  }

  .btnAdd:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .btnSend {
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    padding: 13px 40px;
  }

  .btnCancel {
    content: url("/static/images/icons/cancel.svg");
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    border-radius: 150px;
    background-color: #F2F2F2;
    border-color: #F2F2F2;
    display: block;
    padding:16px;
    transition:0.2s;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
  .btnCancel:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }

  .cliker-text{
      color:#2DB9D1;
  }

    .main{
        padding: 40px 0;
        background:  url("/static/images/bg_azul_categoria.svg") repeat-x;
    }
    .main input {
        font-size: 11px;
        padding-top: 3px;
        border: 1px solid #E0E0E0;
        border-radius: 5px;
    }
    .main-center{
        margin-top: 30px;
        margin-bottom: 120px !important;
        margin: 0 auto;
        max-width: 600px;
        padding: 10px 40px;
        background:#FFFFFF;
        text-shadow: none;
        -webkit-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        -moz-box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        box-shadow: 1px 10px 20px rgba(107, 127, 153, 0.2);
        border-radius: 25px;
    }

    .form-container {
        padding: 30px 0px;
    }

    .form-group > label {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 30px;

        display: flex;
        align-items: center;
        text-align: center;
        letter-spacing: 2px;
        color: #1E2144;
    }
    .placeholder {
        font-family: Muli-Light;
        font-style: normal;
        font-size: 14px;
        line-height: 30px;

        display: flex;
        align-items: center;

        color: #BDBDBD;
    }

    .help {
        margin-top: 50px;
    }

    span.input-group-addon i {
        color: #009edf;
        font-size: 17px;
    }

     @media(max-width: 768px){
          h5 {
        font-size: 24px;
        line-height: 35px;
        margin: 0px 0px;
    }

        .main-center{
      
        background: none;
        -webkit-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        -moz-box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        box-shadow:0px 0px 0px rgba(107, 127, 153, 0.2);
        }

.btnSend {
    width: 100%;
    font-family: Muli-Bold;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.3px;
    background: #2DB9D1;
    border-color: #2DB9D1 !important;
    border-radius: 18px;
    color: #FFFFFF;
    display: block;
    margin-top: 30px;
    padding: 13px 27px;
  }

  .btnSend:hover {
    color: #FFFFFF;
    background-color: #4F4C4C;
    border-color: #4d4c4f !important;
  }
        
     }
</style>